import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { DailyLogService } from '../../../services/daily-log/daily-log.service';
import * as moment from 'moment';
import { WeatherReadingsService } from '../../../services/weather-readings/weather-readings.service';
import { WeatherRemarkEditor } from '../../../models/weather-readings/weather-readings.models';
import { WeatherLogPage } from '../weather-log/weather-log';
import { LockedDayService } from '../../../services/locked-day/locked-day.service';
import { DateService } from '../../../services/date/date.service';
import { WeatherPermissions } from '../../../models/permissions/permission.models';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-weather-remark-edit',
  templateUrl: 'weather-remark-edit.html',
})
export class WeatherRemarkEditPage {
  @Input('projectId') projectId: number;

  config = AppConfig.settings;
  loading: boolean;
  dailyLogDate: PtLuxonDate = new PtLuxonDate();
  dailyLogDisplayDate: string;
  permissions: WeatherPermissions = new WeatherPermissions();

  editor: WeatherRemarkEditor = new WeatherRemarkEditor();

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private dailyLogService: DailyLogService,
              private weatherReadingService: WeatherReadingsService,
              private dateService: DateService,
              private lockedDayService: LockedDayService,
              private toastCtrl: ToastController,
              private permissionsService: PermissionsService,
  ) {
    this.projectId = this.navParams.get('projectId');
  }

  async ionViewDidLoad() {
    this.loading = true;
    this.dailyLogDate = await this.dailyLogService.getCurrentLogDay();
    this.permissions = await this.permissionsService.weatherPermissions();

    if (this.dailyLogDate.dateTime) {
      this.dailyLogDisplayDate = this.dailyLogDate.dateTime.toFormat('EEEE, dd MMMM y');
    }

    if (this.projectId) {
      this.weatherReadingService.getWeatherRemarkEditorForDay(this.dailyLogDate, this.projectId).then(editor => {
        if (!editor) {
          this.editor = {
            projectId: this.projectId,
            date: this.dailyLogDate.dateTime,
            weatherRemark: null,
            weatherForecast: null,
            dateOffset: null
          };
        } else {
          this.editor = editor;
        }

        this.loading = false;
      });
    } else {
      this.loading = false;
    }

  }

  async save() {
    await this.weatherReadingService.saveWeatherRemark(this.editor);

    this.presentSaveToast();

    this.navCtrl.setRoot(WeatherLogPage);
  }

  presentSaveToast(): Promise<any> {
    const toast = this.toastCtrl.create({
      message: 'Weather Remarks Saved',
      duration: 3000,
      position: 'bottom'
    });

    return toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-remark-edit/weather-remark-edit.ts